import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import AOS from 'aos';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}
//console.log('AOS', AOS);
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err))
   .then(() => {
    AOS.init({ duration: 800, once: true }); // default options
  });
